import React, { Fragment, JSX, useEffect, useState } from "react";
import Loader from "../../shared/loader/loader";
import { DownloadIcon } from "../../../assets/icons/index";
import {
  downloadaAnswerKeySupersheet,
  previewSuperSheet,
} from "../../../api/supersheet.service";
interface SupersheetProps {
  title?: string;
  downloadWS?: any;
  filePath?: string;
  userId?: number;
  isAnswerKey?: boolean;
  supersheetId?: number;
}

function SupersheetFilePreview(props: SupersheetProps): JSX.Element {
  const [supersheetURL, setSupersheetURL] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const downloadAnswerKeyFile = () => {
    downloadaAnswerKeySupersheet(props?.supersheetId, props?.userId).then(
      (response) => {
        const file = response.data;
        const fileURL = URL.createObjectURL(file);
        setSupersheetURL(fileURL);
      }
    );
  };

  const getSupersheetPreview = async () => {
    const fileURL = props?.filePath;
    if (fileURL) {
      previewSuperSheet(fileURL).then((res) => {
        setLoading(true);
        setSupersheetURL(res.data);
      });
    }
  };

  useEffect(() => {
    props.isAnswerKey ? downloadAnswerKeyFile() : getSupersheetPreview();
  }, []);

  return (
    <Fragment>
      {loading && <Loader />}
      <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg h-full">
        <div className="relative flex">
          <div className="w-full mt-4 mb-4 flex justify-between">
            {props?.title}
            {props?.filePath && (
              <div className="flex relative cursor-pointer rounded-lg font-medium">
                <DownloadIcon className="w-4 text-gray-500 group-hover:text-blue-500 mr-1"></DownloadIcon>

                <span className="text-blue-700 group-hover:text-blue-500">
                  <a href={supersheetURL} target={"_blank"} rel="noreferrer">
                    {props?.filePath}
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
        {supersheetURL && (
          <iframe
            src={supersheetURL}
            title={props?.title}
            style={{ width: "100%", height: "100%" }}
            onLoad={() => setLoading(false)}
          ></iframe>
        )}
      </div>
    </Fragment>
  );
}

export default SupersheetFilePreview;
